export default __webpack_public_path__ + "static/media/Priest's Boots of the Underworld.d5ea67be.jpg";